var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-bar',{attrs:{"title":"平安成电智慧通行"}}),_c('div',{staticClass:"spinner"},[_c('md-progress-spinner',{staticClass:"md-primary",attrs:{"md-stroke":4,"md-diameter":50,"md-mode":"indeterminate"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }